<template>
  <el-drawer
    class="mobile-drawer"
    :visible="display"
    @close="$emit('close')"
    size="400px"
    :show-close="false"
    :withHeader="false"
  >
    <template v-slot="body">
      <div class="drawer__container">
        <div class="new-feedback__header">
          <div class="new-feedback__header__title">
            <font-awesome-icon :icon="['fal', 'megaphone']" />
            <p>{{ $t('knowledge.modals.feedback.sendToManager') }}</p>
          </div>
        </div>
        <div class="new-feedback__container">
          <feedback-view
            :collection-path="path"
            :main-content="content"
            :content-parents="contentParents"
            :entity="entity"
            :report-recipients="assignableEntities"
            @send-feedback="sendAgentFeedback"
            @select-item="handleSelectItem"
            @cancel="handleClose"
          />
        </div>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'mayday-web-feedback-drawer',
  components: {},
  props: {
    display: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      default: () => ({}),
    },
    contentParents: {
      type: Array,
      default: () => [],
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    path: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      feedback: '',
      hasNodeLinked: true,
      localDisplay: this.display,
      isWebParametric: false,
      isWeb: false,
    };
  },
  computed: {
    feedbackAdminPath() {
      const { path } = this.$route;

      const splittedPath = path.split('/');
      const startContentRouteIndex = this.isWebParametric ? 2 : 4;

      return (
        'knowledge/' +
        splittedPath
          .splice(startContentRouteIndex, splittedPath.length - 1)
          .join('/')
      );
    },
    assignableEntities() {
      let assignableEntities = [];
      let reachableRecipients = this.reachableRecipients;
      reachableRecipients.forEach((recipient) => {
        recipient.options.forEach((option) => {
          assignableEntities.push({
            username: option.label,
            value: {
              id: option.value,
              type: option.type === 'role' ? 'group' : 'collaborator',
            },
          });
        });
      });
      return assignableEntities;
    },
    ...mapGetters(['reachableRecipients']),
  },
  async mounted() {
    await this.getUserInfos();
    this.hasNodeLinked = !!this.content.id;
    this.isWebParametric = this.$route.path.includes('web-parametric');
    this.isWeb = this.$route.path.includes('web');
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    sendAgentFeedback(payload) {
      const { recipientId, groupId } = payload;
      const { path, tags } = this.extractContext();
      const { entityId, entityType } = this.extractEntity();
      const feedback = {
        recipientId,
        groupId,
        path,
        feedback: this.feedback,
        tags,
        hasNodeLinked: this.hasNodeLinked,
        entityId,
        entityType,
      };
      this.storeEvent(feedback);
      this.$emit('success');
    },
    extractContext() {
      let path, tags;
      if (this.hasNodeLinked) {
        path = [this.feedbackAdminPath];
        tags = [this.content.label];
      } else {
        path = [];
        tags = [];
      }
      return { path, tags };
    },
    extractEntity() {
      let entityId, entityType;
      if (this.hasNodeLinked) {
        entityId = this.content.id;
        entityType = this.content.type;
      } else {
        entityId = null;
        entityType = null;
      }
      return { entityId, entityType };
    },
    storeEvent(feedback) {
      if (!this.isWebParametric && !this.isWeb) return;

      if (feedback.hasNodeLinked) {
        this.$services.events.content.feedback(
          this.content,
          feedback,
          window.location.href,
          this.isWebParametric ? 'WEB_PARAMETRIC' : 'MAYDAY_WEB',
        );
      } else {
        this.$services.events.general.feedback(
          feedback,
          window.location.href,
          this.isWebParametric ? 'WEB_PARAMETRIC' : 'MAYDAY_WEB',
        );
      }
    },
    async handleSelectItem(item) {
      let { type, id, knowledgeId } = item;
      this.$router.push({
        path: await this.createRedirectUrl({
          entityType: type,
          entityId: id,
          target: `web/knowledge/${knowledgeId}`,
        }),
      });
      this.$emit('close');
    },
    ...mapActions('webKnowledgeModule', ['sendFeedback', 'getUserInfos']),
    ...mapActions(['createRedirectUrl']),
  },
  watch: {
    localDisplay() {
      if (!this.localDisplay) this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer__container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.new-feedback__container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
}

.new-feedback__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  height: 60px;
  background-color: $blue-mayday;
}

.new-feedback__header__title {
  font-size: 20px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;

  p {
    font-size: 24px;
    font-weight: 500;
    font-family: Lato, sans-serif;
    margin: 0;
  }
}

.new-feedback__header__close {
  cursor: pointer;
  border: none;
}

.contribution__editor {
  border: 1px solid $grey-4-mayday;
  border-radius: 4px;
  min-height: 15vh;
  max-height: 45vh;
  overflow: auto;
}

:deep() .el-drawer__header {
  margin-bottom: 0;
  background-color: $blue-mayday !important;
  color: white;
  padding: 16px;

  .el-drawer__title {
    font-size: 16px;
    color: white;
    font-weight: 500;
  }
}

:deep() .send-comment__button {
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep() button {
  border: none;
}

:deep() .form-group:first-of-type .main-input {
  height: 100%;
}

:deep() .attachment-size {
  white-space: nowrap;
}

@media (max-width: 991px) {
  .mobile-drawer {
    :deep() .el-drawer {
      width: 100% !important;
    }
  }
}
</style>
